export default __webpack_public_path__ + "static/media/teksan-logo-light.6721ccce.png";